<template>
  <span ref="svg" class='svgItem' v-html="dataIcon" v-bind:style="computedSize"  v-show="showed">
  </span>
</template>

<script>
import { getCssVarValue } from '../../services/utility.js';

/* eslint-disable import/no-webpack-loader-syntax */
export default {
    name: 'svg-item',
    data () {
        return {
            dataIcon: null,
            showed: false
        };
    },
    props: ['icon', 'size', 'color', 'clickeable', 'customAttribute', 'custom'],
    mounted () {
        this.language = this.$getLang();
        if (!this.custom) {
            this.dataIcon = require('!svg-inline-loader!../../assets/svg/' + this.icon + '.vue.svg');
        } else {
            this.dataIcon = this.$svg(this.icon + '.vue.svg');
        }
        this.$nextTick(() => {
            if (this.$refs.svg) {
                this.$refs.svg.children[0].style.width = (this.size || 48) + 'px';
                this.$refs.svg.children[0].style.height = (this.size || 48) + 'px';
                this.$refs.svg.children[0].style.verticalAlign = 'middle';
                this.$refs.svg.children[0].style.display = 'inline-block';
                if (this.color) {
                    this.$refs.svg.children[0].style.fill = this.color.indexOf('--') !== -1 ? getCssVarValue(this.color) : this.color;
                };
                if (this.customAttribute) {
                    this.$refs.svg.getElementsByTagName(this.customAttribute.tag)[this.customAttribute.children].setAttribute([this.customAttribute.attribute], this.customAttribute.value.indexOf('--') !== -1 ? getCssVarValue(this.customAttribute.value) : this.customAttribute.value);
                };
                if (this.clickeable) {
                    this.$refs.svg.children[0].style.cursor = 'pointer';
                };
                this.showed = true;
            }
        });
    },
    computed: {
        computedSize () {
            let size = 48;
            if (this.size) {
                size = this.size;
            }
            return {
                width: size + 'px',
                height: size + 'px'
            };
        }
    },
    watch: {
        color (newValue, oldValue) {
            if (newValue) {
                this.$refs.svg.children[0].style.fill = newValue.indexOf('--') !== -1 ? getCssVarValue(newValue) : newValue;
            };
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/elements/SvgItem.vue